import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { EnquiryModel } from '../models/index';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class ContactService {
    protected url = 'api/users';

    constructor(private http: HttpClient) {}

    sendEnquiry(model: EnquiryModel): Observable<boolean> {
        return this.http.post<boolean>(`${environment.webApiBaseAddress}/${this.url}/UserEnquiry`, model);
    }
}
